<template>
  <div id="pageTrack">
    <v-container fluid>
      <TopAppBar :isHome="true" :texts="texts" v-if="showSearch" />
      <v-scroll-y-reverse-transition>
        <SearchPage v-if="showSearch && $store.state.home" />
      </v-scroll-y-reverse-transition>

      <EcotraceTemplate
        v-if="frigorifico === 'ecotrace'"
        :initialTrackOrigem="trackOrigem"
      />
      <TemplateSeara v-if="frigorifico === 'seara'" />
      <TemplateFrigol v-if="frigorifico === 'frigol'" />
      <TemplateFriboi v-if="frigorifico === 'friboi'" />
    </v-container>
  </div>
</template>

<script>
import axios from 'axios'
import moment from 'moment'

import langPTBR from '@/templates/ecotrace/pt-br.ts'
import langCN from '@/templates/ecotrace/cn.ts'

import TopAppBar from '@/components/TopAppBar'

import EcotraceTemplate from '../templates/ecotrace/EcotraceTemplate'
import TemplateSeara from '../templates/seara/SearaTemplate'
import TemplateFrigol from '../templates/frigol/FrigolTemplate'
import TemplateFriboi from '../templates/friboi/FriboiTemplate'

import SearchPage from './SearchPage'

const BRAND_TO_TEMPLATE = {
  seara: 'seara',
  friboi: 'friboi'
}

export default {
  components: {
    TopAppBar,
    EcotraceTemplate,
    TemplateSeara,
    TemplateFrigol,
    TemplateFriboi,
    SearchPage
  },

  data() {
    return {
      frigorifico: '',
      texts: {},
      trackOrigem: null,
      loading: false
    }
  },

  computed: {
    showSearch() {
      return !this.frigorifico && !this.loading
    }
  },

  created() {
    this.applyLang()

    if (!this.$route.query.sif) return

    this.loading = true
    const dtprod = moment(this.$route.query.dp, 'YYYYMMDD').format('YYYY-MM-DD')
    const url = `${
      process.env.VUE_APP_API_URL
    }/production-order/bovine?dt_desossa=${dtprod}&nr_lote_abate=${parseInt(
      this.$route.query.lp
    )}&ind_numero=${this.$route.query.sif}&sku=${this.$route.query.sku}`

    axios
      .get(url)
      .then((response) => {
        this.trackOrigem = response.data
        const brand =
          response.data && response.data.industry
            ? response.data.industry.brand
            : null
        this.frigorifico = BRAND_TO_TEMPLATE[brand] || 'ecotrace'
      })
      .catch((err) => {
        // eslint-disable-next-line no-console
        console.error(err)
      })
      .finally(() => {
        this.loading = false
      })
  },

  methods: {
    applyLang() {
      switch (this.$route.query.lg) {
        case 'pt-br':
        case 'pt':
          this.texts = langPTBR
          break
        case 'cn':
        case 'zh-cn':
        case 'zhHans':
          this.texts = langCN
          break
        default:
          this.texts = langPTBR
      }
    }
  }
}
</script>
<style lang="scss" scoped>
#pageTrack::v-deep {
  background-color: $primary-color;
  height: 100%;
  margin: 0 auto;
  max-width: 100%;
  min-height: 100vh;
  overflow: hidden;
  width: 420px;

  .container {
    padding: 0;
  }

  .top {
    background-color: #fff;
    padding: 20px;
  }

  .content {
    background-color: #fff;
    padding: 20px;
  }

  .error-header-container {
    background-color: #d32f2f;
    box-shadow: none;

    h2 {
      font-family: 'Roboto', Arial, Helvetica, sans-serif;
      font-weight: bold;
    }
  }

  .error-card-text h2 {
    font-family: 'Roboto', Arial, Helvetica, sans-serif;
    font-weight: bold;
  }
}
</style>
